import { createContext, useContext, useEffect, useState } from "react";
import { SOCKET_URL } from "../constants/urls";
import { io } from "socket.io-client";


const SocketContext = createContext()

export const useSocket = () => {
    return useContext(SocketContext)
}

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState()

    useEffect(() => {
        console.log('in socket creation')

        const newSocket = io(SOCKET_URL, {
            transports: ['websocket']
        })
        setSocket(newSocket)

        return () => newSocket.close()
    }, [])

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    )
}
